import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import {  MdEdit, MdVisibility,MdDeleteForever } from "react-icons/md";
import { customerServiceService } from '../../Services'
import { Modal } from "../../Components";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const SalesAndCustomerServiceList = () => {
  const history = useHistory();
  const [listData, setListData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [loader, setLoader] = useState(true);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")
  console.log(user_type, "user_type")
  let obj = {
    CUSTOMERSERVICE : 'Customer Service',
    SALES : 'Sales'
  }

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = () => {
    let param = { ...pagination, page: currentPage, item : 225 };
    if (pagination.search) {
      param["page"] = 1;
    }
    setLoader(true)
    customerServiceService.CustomerServiceList(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const onDeleteSubmit = () => {
    let postData = {
        id: isDeleteOpen,
        is_deleted: true
    }
    customerServiceService.deleteCustomerService(postData).then(res => {
        if (res.status) {
            setIsDeleteOpen(false);
            getItemList()
        }
    })
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="input-group pl-3 w-25">
                <input
                  className="form-control"
                  type="text"
                  placeholder="search..."
                  onChange={(e) =>
                    setPagination({ ...pagination, search: e.target.value })
                  }
                  onKeyPress={(e) => e.key === "Enter" && getItemList()}
                  onKeyUp={(e) =>
                    e.key === "Backspace" &&
                    pagination.search.length <= 0 &&
                    getItemList()
                  }
                ></input>
                <div className="input-group-prepend">
                  <button
                    className="input-group-text pointer search-btn"
                    onClick={() => getItemList()}
                    style={{ backgroundColor: "#e5e4ec" }}
                  >
                    search
                  </button>
                </div>
              </div>
              {
                (CheckAccess(225,"add") ||  user_type === "SUPERADMIN" )&&  
              <button
                className="btn btn-primary btn-sm w-sm waves-effect waves-light"
                onClick={() => history.push("/add-sales-and-customer-service")}
              >
                Add
              </button>
              }
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S.No.</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Employee Code</th>
                    <th>Department</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listData.length > 0 &&
                    listData.map((list, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{list.first_name}</td>
                        <td>{list.last_name}</td>
                        <td>{list.employee_name}</td>
                        <td>{obj[list.department]}</td>
                    
                        <td>
                        {
                           (CheckAccess(225,"edit") || user_type === "SUPERADMIN") && 
                          <MdEdit
                            className="pointer"
                            onClick={() =>
                              history.push(
                                "/edit-sales-and-customer-service?id=" + list._id,
                                list
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                        }

                        {
                          (CheckAccess(225,"delete") ||  user_type === "SUPERADMIN") && 
                          <MdDeleteForever
                              className="pointer"
                              color="red"
                              size="25px"
                              onClick={() => setIsDeleteOpen(list._id)}

                          />
                        }
                          {/* <MdVisibility
                            className="pointer"
                            onClick={() =>
                              history.push("/retailer-details?id=" + list._id)
                            }
                            color="#0323fe"
                            size="25px"
                          /> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {listData.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> List Not Available </h6>
                </div>
              )}
            </div>
          </div>
          {listData.length > 0 && pagination.totalRecord > pagination.limit && (
            <ReactPaginate
              previousLabel={
                <img src="assets/images/prev.svg" height={15} alt="not found" />
              }
              forcePage={currentPage - 1}
              nextLabel={
                <img src="assets/images/next.svg" height={15} alt="not found" />
              }
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={(e) => onPageChangeEvent(e)}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          )}
       
          {Boolean(isDeleteOpen) && (
            <Modal.DeleteItem
              isOpen={Boolean(isDeleteOpen)}
              title="Delete"
              message={`Are you sure want to Delete`}
              onSubmitEvent={() => onDeleteSubmit()}
              handleClose={() => setIsDeleteOpen(false)}
            />
          )}
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};


